import type { Measurement } from "building-types/entities/measurementTypes";
import type { Room } from "building-types/rooms/roomTypes";
import type { BuildingGenerationIssue } from "building-types/settings/buildingGenerationIssue";
import { BuildingGenerationIssueType } from "building-types/settings/buildingGenerationIssue";
import { hostEdgeToGlobalTransform } from "doc/utils/annotation";
import { hostEdgeOriginAngle } from "doc/utils/annotation";
import type { Mat3 } from "geom/mat3";
import { measurementTransform } from "../elements/measurement/measurement";

export function measurementTransformToGlobal(
  measurement: Measurement,
  room: Room,
  mirror: boolean = false,
  issues: BuildingGenerationIssue[],
) {
  const validEdgeId = room.edgeIds.includes(measurement.parentEdgeId);
  if (!validEdgeId) {
    issues.push({
      type: BuildingGenerationIssueType.MEASUREMENT_GENERATION_ISSUE,
      handle: { type: "MEASUREMENT", id: measurement.id },
      message: `Measurement ${measurement.id} is not on a valid edge`,
    });
  }

  const hostGeom = hostEdgeOriginAngle(room, measurement.parentEdgeId, mirror);
  if (hostGeom === undefined) {
    issues.push({
      type: BuildingGenerationIssueType.MEASUREMENT_GENERATION_ISSUE,
      handle: { type: "MEASUREMENT", id: measurement.id },
      message: `Could not determine relationship to host room ${room.id} from measurement ${measurement.id}`,
    });
    return measurement;
  }
  const toGlobalMat: Mat3 = hostEdgeToGlobalTransform(hostGeom.originX, hostGeom.originY, hostGeom.angle);

  return measurementTransform(measurement, toGlobalMat);
}
